import StoresNew from '@/components/product/ProductNew'
import ProductEdit from '@/components/product/ProductEdit'
import ProductNamesEdit from '@/components/product-names/EditProductNames'

export default [
  {
    path: '/product/new',
    name: 'productNew',
    component: StoresNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/product/:id/edit',
    name: 'productEdit',
    component: ProductEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/editProductNames',
    name: 'editProductNames',
    component: ProductNamesEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/productRoutes.js